import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TranslocoPipe } from '@ngneat/transloco';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { HttpClientModule } from '@angular/common/http';
import { ComboBoxComponent } from "@progress/kendo-angular-dropdowns";
import { SelectEvent, UploadComponent } from '@progress/kendo-angular-upload';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { ButtonComponent } from '@progress/kendo-angular-buttons';
import { FormsModule } from '@angular/forms';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { Subject, Subscription } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { sparklesIcon, SVGIcon, printIcon, downloadIcon } from '@progress/kendo-svg-icons';
import { AiService } from 'app/services/ai.service';
import { PageService } from 'app/services/page.service';
import { drawDOM, exportPDF } from '@progress/kendo-drawing';
import { saveAs } from '@progress/kendo-file-saver';

@Component({
    selector: 'app-drake-settings',
    templateUrl: './drake-ai-analysis.component.html',
    styleUrls: ['./drake-ai-analysis.component.scss'],
    standalone: true,
    imports: [CommonModule,
        RouterModule,
        HttpClientModule,
        TranslocoPipe,
        FormsModule,
        LayoutModule,
        ComboBoxComponent,
        UploadComponent,
        InputsModule,
        ButtonComponent
    ]
})
export class DrakeAiAnalysisComponent implements OnInit {

    @ViewChild('aiResponse') private aiResponse: ElementRef;
    scopes: { value: string, text: string }[] = [
        { value: "CSDATAAI", text: "Analisi Credit Safe" },
        //{ value: "CTZDATAAIAGT", text: "Analisi per Agente" },
        //{ value: "CTZDATAAICLI", text: "Analisi per Clienti" },
        //{ value: "CTZDATAAIBRD", text: "Analisi per Brand" },
        //{ value: "CTZSELLOUTAGEBRD", text: "Analisi Sellout Agente/Brand" },
        //{ value: "CTZSELLOUT", text: "Analisi Sellout Globale" }
    ];
    prompts: { value: string, text: string, prompt:string }[] = [
    ];
    models: { value: string, text: string }[] = [
        { value: "claude-3-5-haiku-20241022", text: "Rapida / Molto economica", },
        { value: "claude-haiku-4-5-20251001", text: "Avanzata / Economica",  },
        { value: "claude-sonnet-4-5-20250929", text: "Completa / Meno economica" }
        //claude-opus-4-5-20251101
    ];
    workflows:{ value: string, text: string }[] = [
        { value: "AI.HANDLER", text: "STANDARD", }
    ];
    aiConfig: { scope: string | null, recordId: string | null, prompt: string | null, model: string | null, customPrompt: string | null, files: { ContentBase64: string, ContentType: string, FileName:string }[] | null } = {
        scope: null,
        recordId: null,
        prompt: null,
        model: null,
        customPrompt: null,
        files: null
    };
    idReceived: boolean = false;
    scopeReceived: boolean = false;
    responseArray: string[] = [];
    response: string = '';
    error: string = '';
    userId: string = null;
    usage: { INPUT: { TOKENS: number, COST: number }, OUTPUT: { TOKENS: number, COST: number } } = { INPUT: { TOKENS: 0, COST: 0 }, OUTPUT: { TOKENS: 0, COST: 0 } };
    time: { START: Date | null, END: Date | null } = { START: null, END: null };
    thinking: boolean = false;
    generatedFiles: any[] = [];
    startIndex: number = 0;
    uploadingFile: File;
    wf:string = 'AI.HANDLER';

    public btnIcon: SVGIcon = sparklesIcon;
    public printIcon: SVGIcon = printIcon;
    public downloadIcon: SVGIcon = downloadIcon;

    private messageSubscription?: Subscription;
    public pageData: any;
    public baseData: any = {};
    public currentOperation: string;

    constructor(
        private drakeShared: DrakeSharedService,
        private aiService: AiService,
        private activatedRoute: ActivatedRoute,
        private pageService: PageService) {

        this.drakeShared.currentBaseData = this.baseData;
        this.pageService.getPage('AI.ANALYSIS').subscribe((result: any) => {
            this.pageData = result;
            drakeShared.currentPageData = result;
        });


    }

    async ngOnInit(): Promise<void> {

        this.messageSubscription?.unsubscribe();

        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userObj = JSON.parse(user);
                this.userId = userObj.id;

                this.drakeShared.createWsConnection();

                if (this.drakeShared.ws.connectionState) {
                } else {
                    this.drakeShared.ws.client?.onConnect.subscribe(() => {
                        this.drakeShared.ws.connectionState = true;
                    });
                }

                this.messageSubscription = this.drakeShared.messageSubject.subscribe((value: { type: string, content: any, timestamp: string, notes: string, index: number }) => {
                    console.log("AI_DATA", value);
                    if (value.type == "PARTIAL") {
                        this.responseArray[this.startIndex + value.index] = value.content;
                        this.response = this.responseArray.join('');
                        this.aiResponse.nativeElement.scrollTop = this.aiResponse.nativeElement.scrollHeight;
                        //this.response = this.extractHtmlAndCss(this.response);
                    }
                    else if (value.type == "ERROR") {
                        this.error += value.content;
                        this.time.END = new Date();

                        console.log("TIME_END ERROR", this.time.END)
                        console.error(value.notes);
                    }
                    else if (value.type == "USAGE") {
                        this.usage[value.notes.split('_')[0]][value.notes.split('_')[1]] += +(value.content.replace(",", "."));
                        //if (!this.time.END)
                        //    this.time.END = new Date();
                    }
                    else if (value.type == "FILE") {
                        console.error('FILE', value);
                        this.generatedFiles.push({ content: value.content, metadata: JSON.parse(value.notes) })
                    }
                    else if (value.type == "START") {
                        this.thinking = true;
                        //if (!this.time.START)
                        //    this.time.START = new Date();
                        this.aiResponse.nativeElement.scrollTop = 0;
                    }
                    else if (value.type == "END") {
                        this.thinking = false;
                        this.startIndex = this.responseArray.length;

                        this.time.END = new Date();
                        console.log("TIME_END", this.time.END)

                        const regex = /```(html|json)([\s\S]+?)```/g;

                        // Eseguo il match
                        const match = regex.exec(this.response);

                        if (match) {
                            this.response = match[2].trim();
                            console.log(this.response);
                        } else {
                            //this.response = "Errore nella generazione dell'analisi richiesta.";
                            console.log("Nessun blocco HTML/JSON trovato.");
                        }
                        console.log("AI_RESPONSE", this.response);

                        this.aiResponse.nativeElement.scrollTop = 0;
                        //window['lastResponse'] = this.response;
                    }
                })

                this.drakeShared.changeStatusSubject.subscribe((value: { type: string, content: any, timestamp: string }) => {
                    this.currentOperation = value.content;
                });

            } catch (error) {
                console.error('Error parsing user JSON:', error);
            }

            this.activatedRoute.queryParamMap.subscribe(params => {

                this.aiConfig.scope = params.get('scope');
                if (this.aiConfig.scope)
                    this.scopeReceived = true;

                this.aiConfig.recordId = params.get('recordId');
                if (this.aiConfig.recordId)
                    this.idReceived = true;

                this.onScopeChange(null);
            });

        } else {
            console.error('User not found in local storage');
        }
    }

    async startAnalysis() {
        if (this.drakeShared.ws.connectionState) {
            this.responseArray = [];
            this.response = '';
            this.error = '';
            this.usage.INPUT.TOKENS = 0;
            this.usage.INPUT.COST = 0;
            this.usage.OUTPUT.TOKENS = 0;
            this.usage.OUTPUT.COST = 0;
            this.time.START = null;
            this.time.END = null;
            this.currentOperation = "Avvio operazione";
            this.thinking = true;
            this.time.START = new Date();
            console.log("TIME_START", this.time.START)
            this.time.END = null;
            this.generatedFiles = [];
            this.startIndex = 0;

            if (this.uploadingFile) {
                this.aiConfig.files = [await this.readFileAsync(this.uploadingFile)];
            }

            /*this.drakeShared.ws.client
                ?.publish(
                    `${this.userId}/DRAKEAI/SCOPE/${this.aiConfig.scope}/REQUEST`,
                    JSON.stringify({
                        message: JSON.stringify(this.aiConfig),
                        token: localStorage.getItem('accessToken'),
                    })
                )
                .subscribe((message) => {
                    console.log('Risposta ricevuta:', message);
                });*/
                
            let aiConfigClone = JSON.parse(JSON.stringify(this.aiConfig));

            aiConfigClone.customPrompt = 'Recupera il record con id "' + this.aiConfig.recordId + '". ' + aiConfigClone.customPrompt;

            this.drakeShared.ws.client
                ?.publish(
                    `${this.userId}/MANUAL/GENERAL/WORKFLOW/${this.wf}/LAUNCH`,
                    JSON.stringify({
                        message: JSON.stringify(aiConfigClone),
                        token: localStorage.getItem('accessToken'),
                    })
                )
                .subscribe((message) => {
                    console.log('Risposta ricevuta:', message);
                });
            this.messageSubscription?.unsubscribe();
        }
    }

    extractHtmlAndCss(input: string): string {
        let result = "";

        // Estrae i blocchi HTML
        const htmlMatches = input.matchAll(/```html\s*([\s\S]*?)```/gm);
        for (const match of htmlMatches) {
            result += match[1].trim() + "\n";
        }

        // Estrae i blocchi CSS (li mette dentro un <style>)
        const cssMatches = input.matchAll(/```css\s*([\s\S]*?)```/gm);
        let cssCode = "";
        for (const match of cssMatches) {
            cssCode += match[1].trim() + "\n";
        }

        if (cssCode) {
            result += `<style>\n${cssCode.trim()}\n</style>\n`;
        }

        return result.trim();
    }

    onSelect(e: SelectEvent): void {
        // File reale (HTML5 File API)
        this.uploadingFile = e.files[0].rawFile as File;
    }

    readFileAsync(file: File): Promise<{ ContentBase64: string, ContentType: string, FileName: string }> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();

            reader.onload = () => {
                const result = reader.result as string;
                // formato: data:<mime>;base64,<base64>
                const [header, base64] = result.split(',');

                const contentType =
                    header.match(/data:(.*);base64/)?.[1] ?? file.type;

                resolve({
                    ContentBase64: base64,
                    ContentType: contentType,
                    FileName: file.name.normalize('NFC')
                });
            };

            reader.onerror = () => reject(reader.error);

            reader.readAsDataURL(file);
        });
    }

    downloadBase64File(base64: string, fileName: string, mimeType: string): void {
        const byteCharacters = atob(base64);
        const byteNumbers = new Array(byteCharacters.length);

        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        const blob = new Blob([byteArray], { type: mimeType });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        a.click();

        window.URL.revokeObjectURL(url);
    }

    onScopeChange(event: any) {
        console.log("onScopeChange");
        this.aiService.getPrompts(this.aiConfig.scope).subscribe(result => {
            this.prompts = [{ value: null, text: "-MANUALE-", prompt: '' }].concat(result.data.map(p => { return { value: p._id, text: p.Title, prompt: p.PromptText } }))
        })
    }

    onPromptChange(event: any) {

        this.aiConfig.customPrompt = this.prompts.find(p => p.value == event).prompt;
    }

    /*calculateCost(tokens: number, mode: "input" | "output") {
        if (!tokens)
            return 0;
        // Trova il modello selezionato
        const selectedModel = this.models.find(
            m => m.value === this.aiConfig.model
        );

        if (!selectedModel) {
            console.warn("Modello non trovato:", this.aiConfig.model);
            return 0;
        }

        const cost = tokens * selectedModel[mode];
        // Arrotonda a 6 cifre decimali per evitare rumore numerico
        return cost.toFixed(6);
    }*/

    calculateTime(time: { START: Date | null; END: Date | null }): string {
        if (!time.START || !time.END) return "0s";

        const diffMs = Math.abs(time.END.getTime() - time.START.getTime());

        const hours = Math.floor(diffMs / (1000 * 60 * 60));
        const minutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

        const parts: string[] = [];
        if (hours) parts.push(`${hours}h`);
        if (minutes) parts.push(`${minutes}m`);
        if (seconds || parts.length === 0) parts.push(`${seconds}s`);

        return parts.join(" ");
    }

    ngOnDestroy() {
        // Sempre buona pratica: unsubscribe al destroy
        this.messageSubscription?.unsubscribe();
    }

    public async printPDF(): Promise<void> {


        const element = this.aiResponse.nativeElement;
        const scope = this.aiConfig.scope;
        drawDOM(element, {
            forcePageBreak: ".page-break",
            scale: 0.6,
            paperSize: "A4",
            margin: { left: "0.3cm", top: "0.3cm", right: "0.3cm", bottom: "0.3cm" },
        })
            .then(function (group) {
                return exportPDF(group, {
                    paperSize: "A4",
                    margin: { left: "0.3cm", top: "0.3cm", right: "0.3cm", bottom: "0.3cm" },
                    landscape: false,
                });
            })
            .then(function (data) {
                var x = saveAs(data, 'AI_Report_' + scope + '_' + new Date().toISOString().replace(/[-:TZ.]/g, '') + ".pdf");
                console.log('saved', x)
            })
            .catch(function (error) {
                console.error('Error generating PDF:', error);
            });
    }
}
